var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { SharedService } from '../../services/shared.service';
import { KeycloakService } from '../../services/keycloak.service';
var PreferenciaComponent = (function () {
    function PreferenciaComponent(_service, _sservice, router, route) {
        this._service = _service;
        this._sservice = _sservice;
        this.router = router;
        this.route = route;
    }
    PreferenciaComponent.prototype.ngOnInit = function () {
        var _this = this;
        var that = this;
        this._service.findPreferencia(KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.preferencia = response;
            _this.onChangeOrg(_this.preferencia.organismoSeleccionado);
            _this.onChangeDep(_this.preferencia.dependenciaSeleccionada);
        });
    };
    PreferenciaComponent.prototype.onChangeOrg = function (value) {
        var _this = this;
        //console.log("org: " + value);
        this.preferencia.organismos.forEach(function (org) {
            if (org.orgId == value) {
                _this.selectedOrg = org;
            }
        });
    };
    PreferenciaComponent.prototype.onChangeDep = function (value) {
        var _this = this;
        //console.log("dep: " + value);
        this.selectedOrg.dependencias.forEach(function (dep) {
            if (dep.depId == value) {
                _this.selectedDep = dep;
            }
        });
    };
    PreferenciaComponent.prototype.onChangeCar = function (value) {
        //console.log("car: " + value);
    };
    return PreferenciaComponent;
}());
PreferenciaComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'my-app',
        templateUrl: 'preferencia.component.html'
    }),
    __metadata("design:paramtypes", [CommonService, SharedService,
        Router, ActivatedRoute])
], PreferenciaComponent);
export { PreferenciaComponent };
//# sourceMappingURL=preferencia.component.js.map